import { getInfo as getCompanyInfo } from '@/apis/company'
import { asyncRoutes, constantRoutes, resetRouter } from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission (roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes (routes, roles) {
  const res = []

  if (routes) {
    routes.forEach(route => {
      const tmp = { ...route }
      if (hasPermission(roles, tmp)) {
        if (tmp.children) {
          tmp.children = filterAsyncRoutes(tmp.children, roles)
        }
        res.push(tmp)
      }
    })
  }

  return res
}

const state = {
  permissionRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.permissionRoutes = constantRoutes.concat(routes)
  },
  RESET_ROUTES: () => {
    resetRouter()
  }
}

const actions = {
  generateRoutes ({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      if (roles.includes('系统管理员')) {
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },

  // check opration permission
  checkFunction ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getCompanyInfo(params.companyId, params.userId).then(response => {
        const { data } = response

        let hasPermission = false
        if (data) {
          if (params.userId === data.belongUser) {
            hasPermission = true
          } else {
            if (!!data.adminFunctionList && data.adminFunctionList.length > 0) {
              const fun = data.adminFunctionList.find(fun => fun.code === params.code)
              if (fun) {
                hasPermission = fun.enableFlag
              }
            }
          }
        }
        resolve(hasPermission)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
